import type { ReactNode } from 'react'
import { useAuthStatus } from '../api/auth-listener'

// auth 起動中（configuring）はアプリ本体の描画をブロックする。Me とは無関係な起動ゲート。
const AuthBootGate: React.FC<{children: ReactNode}> = ({children}) => {
  if (useAuthStatus() === 'configuring') return (
    <div style={{
      textAlign: 'center',
      alignContent: 'center',
      height: '100%',
      minHeight: '50vh',
      width: '100%',
      color: '#bbb'
    }}>
      Retrieving user...
    </div>
  )
  return <>{children}</>
}

export default AuthBootGate
